import { useCallback, useContext } from 'react'

import { VariantSelectionFormContext } from '../../../../../app/_components/forms/VariantSelectionForm'
import { EmbroideryTypeKey } from '../../../../../containers/EmbroideryContainer/combination-rules/types'
import { useEmbroiderySelection } from '../../../../../containers/EmbroideryContainer/providers/EmbroiderySelectionProvider'
import { EmbroideryModalShell } from '../../EmbroideryModalShell'
import { EmbroideryPreview } from '../../parts/preview/EmbroideryPreview'
import { PreviewDraftProvider } from '../../parts/preview/PreviewDraftContext'

import { AddToBagFooter, ConfirmFooter } from './DtcModalFooters'
import { DtcOptionsPanel } from './DtcOptionsPanel'
import { useDtcSectionNavigation } from './useDtcSectionNavigation'

export type DtcEmbroideryModalProps = {
  isOpen: boolean
  // The editor to open on, or `null` for the option list
  initialTypeKey: EmbroideryTypeKey | null
  onClose(): void
}

/** The DTC embroidery modal. Must be mounted inside a `DtcEmbroideryProvider`. */
export const DtcEmbroideryModal: React.FC<DtcEmbroideryModalProps> = ({
  isOpen,
  initialTypeKey,
  onClose,
}) => {
  const { openTypeKey, openType, goBack, headerTitle, headerTitleRef } =
    useDtcSectionNavigation(initialTypeKey)
  const { confirm } = useEmbroiderySelection()
  // Outside the variant selection form (a kit) there is no variant to add to the bag
  const confirmOnly = useContext(VariantSelectionFormContext) === undefined

  const handleConfirm = useCallback(() => {
    confirm()
    onClose()
  }, [confirm, onClose])

  return (
    <PreviewDraftProvider>
      <EmbroideryModalShell
        isOpen={isOpen}
        onClose={onClose}
        title={headerTitle}
        titleRef={headerTitleRef}
        onBack={goBack}
        preview={<EmbroideryPreview />}
      >
        <DtcOptionsPanel
          openTypeKey={openTypeKey}
          onOpenType={openType}
          onCloseType={() => goBack?.()}
          footer={
            confirmOnly ? (
              <ConfirmFooter onConfirm={handleConfirm} />
            ) : (
              <AddToBagFooter onAdded={handleConfirm} />
            )
          }
        />
      </EmbroideryModalShell>
    </PreviewDraftProvider>
  )
}
